import { Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router';
import { SplashScreen } from '@/components/SplashScreen';
import { translate, useLocale } from '@/lib/i18n';
import { consumeNativeOpenPath } from '@/lib/native-push';
import { isNative } from '@/lib/platform';

export function App() {
  const locale = useLocale((state) => state.locale);

  useEffect(() => {
    document.documentElement.lang = locale;
    if (!window.location.pathname.startsWith('/p/')) {
      document.title = translate(locale, 'Семья P&Co — семейное наследие');
    }
  }, [locale]);

  useEffect(() => {
    if (!isNative()) return;
    void consumeNativeOpenPath().then((path) => {
      if (path) window.location.hash = path;
    });
  }, []);

  return (
    <Suspense fallback={<SplashScreen />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
